import React from 'react';
import { Container, Row, Col, Table, Button, Form } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import { useEditProducts } from '../Context/EditProductContext';
import MakeRequest from '../Helpers/MakeRequest';

const EditProductTypes = () => {
    const { l } = useOutletContext();
    const { state, setProductTypes, setSaveDisabled } = useEditProducts();
    const { productTypes, products } = state;

    const handleDeleteType = async (idx) => {
        if (productTypes[idx].typeSwe === "" && productTypes[idx].typeEng === "") {
            setProductTypes(productTypes.filter((_, i) => i !== idx));
            return;
        }
        if (window.confirm(l("Är du säker på att du vill ta bort denna produkttyp?", "Are you sure you want to delete this product type?"))) {
            const response = await MakeRequest(null, `content/products/productTypes/${productTypes[idx].typeEng}`, 'delete');
            if (response.status === 200) {
                setProductTypes(productTypes.filter((_, i) => i !== idx));
            } else {
                alert(l("Misslyckades med att ta bort produkttypen.", "Failed to delete the product type."));
            }
        }

    };

    const handleAddType = () => {

        const randomId = (length = 30) => {
            const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        };

        setSaveDisabled(false);
        setProductTypes([
            ...productTypes,
            {
                typeSwe: '',
                typeEng: '',
                subcategories: [],
                id: randomId()
            }
        ]);
    };

    const handleUpdateType = (idx, field, value) => {
        setSaveDisabled(false);
        const updatedTypes = [...productTypes];
        updatedTypes[idx][field] = value;
        setProductTypes(updatedTypes);
    };

    return (
        <Col>
            <Form.Label
                column
                style={{ display: "flex", alignItems: "center", fontWeight: "bold" }}
            >
                {l("Lägg till produkttyp", "Add product type")}
                <Button
                    size="sm"
                    style={{ marginLeft: 10 }}
                    onClick={handleAddType}
                    title={l("Lägg till ny rad", "Add new row")}
                >
                    <i className="fa-solid fa-plus"></i>
                </Button>
            </Form.Label>

            {productTypes.length === 0 && (
                <Row style={{ color: "#888", fontStyle: "italic", padding: "10px 0" }} className='mx-1 p-0'>
                    {l("Inga produkttyper har lagts till.", "No product types have been added.")}
                </Row>
            )}
            {productTypes.length > 0 && (
                <Table bordered hover size="sm" style={{ backgroundColor: "white" }}>
                    <thead>
                        <tr>
                            <th>{l("Produkttyp Svenska", "Product type Swedish")}</th>
                            <th>{l("Produkttyp Engelska", "Product type English")}</th>
                            <th>{l("Underkategorier", "Subcategories")}</th>
                            <th style={{ width: "80px" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {productTypes.map((productType, idx) => (
                            <tr key={idx}>
                                {/* Product type column */}
                                <td style={{ width: "22.5%" }}>
                                    <Form.Control
                                        type="text"
                                        placeholder={l("Typ", "Type")}
                                        value={productType.typeSwe || ''}
                                        onChange={(e) => {
                                            setSaveDisabled(false);
                                            handleUpdateType(idx, 'typeSwe', e.target.value);
                                        }}
                                    />
                                </td>
                                <td style={{ width: "22.5%" }}>
                                    <Form.Control
                                        type="text"
                                        placeholder={l("Typ", "Type")}
                                        value={productType.typeEng || ''}
                                        onChange={(e) => {
                                            setSaveDisabled(false);
                                            handleUpdateType(idx, 'typeEng', e.target.value);
                                        }}
                                    />
                                </td>

                                {/* Subcategories column */}
                                <td style={{ width: "50%" }}>
                                    {productType.subcategories?.length > 0 && (<>
                                        <Row>
                                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>

                                                <Form.Label>{l('Svenska', 'Swedish')}</Form.Label>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                                                <Form.Label>{l('Engelska', 'English')}</Form.Label>
                                            </Col>
                                        </Row>
                                    </>)}

                                    {productType.subcategories?.map((sub, sIdx) => (
                                        <Row key={sIdx} className="mb-1">
                                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} style={{ display: "flex", alignItems: "center" }}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={l("Underkategori Svenska", "Subcategory Swedish")}
                                                    value={sub.categorySwe || ''}
                                                    onChange={(e) => {
                                                        setSaveDisabled(false);
                                                        handleUpdateType(idx, 'subcategories', productType.subcategories.map((sc, j) =>
                                                            j === sIdx ? { ...sc, categorySwe: e.target.value } : sc
                                                        ));
                                                    }}
                                                />
                                            </Col>
                                            <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5} style={{ display: "flex", alignItems: "center" }}>
                                                <Form.Control
                                                    type="text"
                                                    placeholder={l("Underkategori Engelska", "Subcategory English")}
                                                    value={sub.categoryEng || ''}
                                                    onChange={(e) => {
                                                        setSaveDisabled(false);
                                                        handleUpdateType(idx, 'subcategories', productType.subcategories.map((sc, j) =>
                                                            j === sIdx ? { ...sc, categoryEng: e.target.value } : sc
                                                        ));
                                                    }}
                                                />
                                            </Col>
                                            <Col xs="auto">
                                                <Button
                                                    size="sm"
                                                    variant="link"
                                                    onClick={() => {
                                                        setSaveDisabled(false);
                                                        handleUpdateType(idx, 'subcategories', productType.subcategories.filter((_, j) => j !== sIdx));
                                                    }}
                                                >
                                                    <i className="fa-solid fa-times" style={{ color: 'red' }}></i>
                                                </Button>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Button
                                        size="sm"
                                        onClick={() => {
                                            setSaveDisabled(false);
                                            handleUpdateType(idx, 'subcategories', [
                                                ...(productType.subcategories || []),
                                                { categorySwe: '', categoryEng: '' }
                                            ]);
                                        }}
                                    >
                                        <i className="fa-solid fa-plus"></i>{" "}
                                    </Button>
                                </td>

                                {/* Actions column */}
                                <td style={{ width: "5%" }}>
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={() => handleDeleteType(idx)}
                                    >
                                        <i className="fa-solid fa-trash"></i>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}

        </Col>
    );
};

export default EditProductTypes;